import React, { useState, useEffect, useRef } from "react";
// import { createTheme } from "@mui/material/styles";
import { AppSingleton, _musicList } from "../services/user_config";
// import ReactPageScroller, { SectionContainer } from "react-page-scroller";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { getYoutubeInfoApi } from "../services/backend";

const MusicSectionListing = () => {
  const [vodInfos, setVodInfos] = useState([]);
  var appSingleton = new AppSingleton();

  useEffect(() => {
    Promise.all(_musicList.map((el) => getYoutubeInfoApi({ url: el.url })))
      .then((responses) => {
        const mappedResponse = responses.map((response, index) => ({
          ..._musicList[index],
          ...response,
        }));
        // console.log("mappedResponse");
        // console.log(mappedResponse);
        setVodInfos(mappedResponse);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  return (
    <>
      {vodInfos.map((el, index) => (
        <Card key={index} sx={{ m: 2 }}>
          <CardActionArea
            onClick={() => {
              appSingleton.navigate("/operation/media-section", {
                state: el,
              });
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                justifyItems: "center",
              }}
            >
              <Box>
                <CardMedia
                  sx={{
                    height: (appSingleton.windowSize.width / 4 / 16) * 9,
                    width: appSingleton.windowSize.width / 4, //(192 * 16) / 9,
                    objectFit: "contain",
                  }}
                  image={el.thumbnail_url}
                  title="green iguana"
                />
              </Box>
              <Box sx={{ textAlign: "left", ml: 4, mr: 2 }}>
                <Typography variant="h6">{el.title}</Typography>
                <Typography variant="p">{el.author_name}</Typography>
                <Typography
                  sx={{
                    position: "absolute",
                    bottom: 32,
                    right: 32,
                  }}
                >
                  {el.provider_name}
                </Typography>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </>
  );
};

export { MusicSectionListing };
